
import Icon from "@/Components/Icon/Icon";
import useTranslation from "@/Hooks/UseTranslation";
import React from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";

const EstimatedDeviation = () => {

  const { t } = useTranslation()

  const dashboard = useSelector((state: any) => state.DashboardReducer)

  const getEstimatedDelayColorClass = () => {

    if (dashboard.delayData.estimatedTotal < 0)
      return 'text-color-atrasada'

    return 'text-color-liberada'
  }

  return (
    <Card className="card-icon-bg card-icon-bg-primary o-hidden mb-4">
      <Card.Body className="text-center">
        <Icon name={`tareas ${getEstimatedDelayColorClass()}`}
          style={{ fontSize: '4rem' }}
        />
        <div className="content ml-3" style={{ maxWidth: 'none' }}>
          <p className="text-muted mt-2 mb-0">
            {t('DASHBOARD:SummaryEstimatedProyectDeviation')}
          </p>
          <p className={`text-24 line-height-1 mb-0 ${dashboard.delayData.estimatedTotal < 0 ? 'text-color-atrasada' : 'text-color-liberada'}`}>
            {dashboard.delayData.estimatedTotal} {t('DASHBOARD:SummaryDeviationDays')}
          </p>
          <p className="text-primary text-1 line-height-1 mb-2">
            <small>
              {dashboard.delayData.estimatedTotal < 0 && '* ' + t('DASHBOARD:SummaryDeviationNegative')}
              {dashboard.delayData.estimatedTotal > 0 && '* ' + t('DASHBOARD:SummaryDeviationPositive')}
              {dashboard.delayData.estimatedTotal === 0 && '* ' + t('DASHBOARD:SummaryDeviationZero')}
            </small>
          </p>
        </div>
      </Card.Body>
    </Card>
  )
}

export default EstimatedDeviation;
